import Vue from "vue"
import axios from "axios"
import Vuex from "vuex"
import {router} from "../../routes"
import VueRouter from "vue-router"



const state  = {
        token : "",
        fbApiKey :"AIzaSyArrAN-S0-cFSZ21tJmiCm14zlBX93OyZQ",
        usermail : "",
}

const getters = {
    isAuthenticated(state){
        return state.token !== ""
    },
    getUserMail(state){
        return state.usermail
    }
}

const mutations = {
    setToken(state, token){
        state.token = token
    },
    clearToken(state){
        state.token = ""
        localStorage.clear()
    },
    setUser(state, usermail){
        state.usermail = usermail
    }
}

const actions = {
    initAuth({dispatch, commit}){
        let token = localStorage.getItem("token")
        let usermail = localStorage.getItem("usermail")
        if(token){
            commit("setToken",token)
            commit("setUser",usermail)
            console.log("token varrrr")
            router.push("/home")
        }else{
            router.push("/login")
            return false
        }
    },
    login({commit, dispatch, state}, authData){
       return axios.post("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyCFrkfZZ7_8HZt0xy6FWJH1Gkg8b3CHuaU",
        {email : authData.email, password : authData.password, returnSecureToken : true }
        ).then(response => {
            console.log(response)
            commit("setToken",response.data.idToken)
            commit("setUser",response.data.email)
            localStorage.setItem("token", response.data.idToken)
            localStorage.setItem("usermail", response.data.email)
        })
    },
    logout({commit, dispatch, state}){
        commit("clearToken")
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/login.js